import { ColumnsType } from 'antd/lib/table';
import { TFunction } from 'react-i18next';
import { Table } from 'antd';
import { Customer } from 'app/cross-cutting-concerns/communication/interfaces/am-sp-api-graphql';

export const getCustomerListSearchColumns = (t: TFunction): ColumnsType<Customer> => [
  {
    title: t('customerList.table.customerName').toLocaleUpperCase(),
    dataIndex: 'customerName',
    width: '40%',
    key: 'customerName',
    ellipsis: true,
    render: (value): JSX.Element => <>{value !== '' ? <span>{value}</span> : <span>N/A</span>}</>,
  },
  {
    title: t('customerList.table.customerNumber').toLocaleUpperCase(),
    dataIndex: 'SAPCustomerNumber',
    width: '40%',
    key: 'SAPCustomerNumber',
    render: (value): JSX.Element => <>{value !== '' ? <span>{value}</span> : <span>N/A</span>}</>,
  },
  Table.SELECTION_COLUMN,
];
